import { registerCommunicationEventHandlers } from '@/modules/communications/handlers/communication.handlers';
import { registerNotificationEventHandlers } from '@/modules/events/handlers/notification.handlers';

/**
 * Punto único de registro de handlers del bus in-process.
 * Llamar una vez al iniciar la app (AppProviders).
 */
export function registerAllEventHandlers(): void {
  registerNotificationEventHandlers();
  registerCommunicationEventHandlers();
}
